<aside class="rail" aria-labelledby="cxp-crl-rail-title">
  <h2 id="cxp-crl-rail-title" class="rail-title">Details</h2>

  <section class="rail-section">
    <div class="rail-section-head">
      <h3 class="rail-section-title">Team</h3>
      @if (contactAllHref(); as href) {
        <a
          andButton
          color="default"
          size="small"
          class="rail-contact-btn"
          [href]="href"
          [dataSelector]="'cxp-crl-rail-contact-all'"
        >Contact</a>
      }
    </div>

    @for (member of team(); track member.staffId) {
      <div class="rail-row">
        <span class="rail-avatar-wrap">
          <span class="rail-avatar" aria-hidden="true">{{ initialsForTeam(member) }}</span>
          @if (member.isOwner) {
            <aiwyn-icon name="star" class="rail-owner-badge" [height]="12" [width]="12" aria-label="Owner"></aiwyn-icon>
          }
        </span>
        <div class="rail-row-text">
          <p class="rail-name" tooltipOverflow>{{ member.name }}</p>
          <a class="rail-email" tooltipOverflow [href]="'mailto:' + member.email">{{ member.email }}</a>
        </div>
        <a
          andButton
          color="ghost"
          size="small"
          class="rail-row-action"
          [href]="'mailto:' + member.email"
          [attr.aria-label]="'Email ' + member.name"
          [dataSelector]="'cxp-crl-rail-team-email'"
        >
          <aiwyn-icon name="mail" class="icon-color-gray-500" [height]="16" [width]="16"></aiwyn-icon>
        </a>
      </div>
    } @empty {
      <p class="rail-empty">No team members available</p>
    }
  </section>

  <section class="rail-section rail-section-client">
    <h3 class="rail-section-title">Client access</h3>

    @for (contact of clientContacts(); track contact.key) {
      <div class="rail-row">
        <span class="rail-avatar-wrap">
          <span class="rail-avatar" aria-hidden="true">{{ initialsForContact(contact) }}</span>
          @if (contact.isOwner) {
            <aiwyn-icon name="star" class="rail-owner-badge" [height]="12" [width]="12" aria-label="Client owner"></aiwyn-icon>
          }
        </span>
        <div class="rail-row-text">
          @if (contact.name) {
            <p class="rail-name" tooltipOverflow>{{ contact.name }}</p>
            @if (contact.email) {
              <a class="rail-email" tooltipOverflow [href]="'mailto:' + contact.email">{{ contact.email }}</a>
            }
          } @else {
            <p class="rail-name rail-name-muted" tooltipOverflow>{{ contactFallbackLabel(contact) }}</p>
          }
        </div>
      </div>
    } @empty {
      <p class="rail-empty">No client recipients on file.</p>
    }
  </section>
</aside>
